var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labelcell"},[_c('div',{staticClass:"lc-label",class:{'is-required': _vm.required}},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2),_c('div',{staticClass:"lc-value"},[_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }